import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import type { RootState } from 'store'
import { generateRouter } from '../routes'

export default function AppRouter() {
  const showBakerModule = useSelector(
    (s: RootState) => s.user.settings?.SHOW_BAKER_MODULE === true
  )

  const router = useMemo(
    () => generateRouter(showBakerModule),
    [showBakerModule]
  )

  return (
    <RouterProvider
      router={router}
      key={showBakerModule ? 'bakers' : 'wheat'}
      future={{ v7_startTransition: true }}
    />
  )
}
